import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, map, of, switchMap } from 'rxjs';
import { memo } from "../util/index.js";
/**
 * @description Get the candidate info for a society
 */

export function candidates(instanceId, api) {
  return memo(instanceId, function () {
    return api.query.society.candidates().pipe(switchMap(function (candidates) {
      return combineLatest([of(candidates), api.query.society.suspendedCandidates.multi(candidates.map(function (_ref) {
        var who = _ref.who;
        return who;
      }))]);
    }), map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          candidates = _ref3[0],
          suspended = _ref3[1];

      return candidates.map(function (_ref4, index) {
        var kind = _ref4.kind,
            value = _ref4.value,
            who = _ref4.who;
        return {
          accountId: who,
          isSuspended: suspended[index].isSome,
          kind: kind,
          value: value
        };
      });
    }));
  });
}